import { render, staticRenderFns } from "./ChargeTypeAdd.vue?vue&type=template&id=613e9c23&"
import script from "./ChargeTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ChargeTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports